module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-400-regular-1e86f96e1a7b3e7ea3d0ceda2c9d3423.woff2";